import { useQuery } from "@apollo/client/react";

export const useOvrseaQuery: typeof useQuery = useQuery;
